import axios from "axios";
import { BACKEND_URL } from "../utils/constant";

const authHeader = (token) => ({
  headers: { authorization: `Bearer ${token}` },
});

const getAll = async (token) => {
  const response = await axios.get(
    `${BACKEND_URL}api/role-permissions`,
    authHeader(token)
  );
  return response;
};

const getMine = async (token) => {
  const response = await axios.get(
    `${BACKEND_URL}api/role-permissions/me`,
    authHeader(token)
  );
  return response;
};

const createRole = async (token, role, modules = []) => {
  const response = await axios.post(
    `${BACKEND_URL}api/role-permissions`,
    { role, modules },
    authHeader(token)
  );
  return response;
};

const updateRole = async (token, role, modules) => {
  const response = await axios.put(
    `${BACKEND_URL}api/role-permissions/${role}`,
    { modules },
    authHeader(token)
  );
  return response;
};

const deleteRole = async (token, role) => {
  const response = await axios.delete(
    `${BACKEND_URL}api/role-permissions/${role}`,
    authHeader(token)
  );
  return response;
};

export default {
  getAll,
  getMine,
  createRole,
  updateRole,
  deleteRole,
};
